/**
 * SpreadsheetNotesNotAvailable Component
 *
 * @component
 * @description This component is displayed when spreadsheet notes are not available for the current context.
 *
 * @returns {JSX.Element} - A JSX element representing the SpreadsheetNotesNotAvailable component.
 */
import { Typography } from '@mui/material';

const SpreadsheetNotesNotAvailable = () => (
  <div style={{ padding: '1rem' }}>
    <Typography variant="body1">Spreadsheet Notes are not available for this item.</Typography>
  </div>
);

export default SpreadsheetNotesNotAvailable;